import { render, staticRenderFns } from "./text-image-alt.vue?vue&type=template&id=18579c8c&scoped=true"
import script from "./text-image-alt.vue?vue&type=script&lang=js"
export * from "./text-image-alt.vue?vue&type=script&lang=js"
import style0 from "./text-image-alt.vue?vue&type=style&index=0&id=18579c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18579c8c",
  null
  
)

export default component.exports